import { t } from '../i18n/idioma';
import { useFechar } from '../input/useAtalhos';
import { Gump } from './Gump';

/** Formato de guerra como vem do servidor. Sem chave, fica como veio. */
const FORMATO_GUERRA: Readonly<Record<string, string>> = {
  kills: 'guilda.guerraMortes',
  time: 'guilda.guerraTempo',
  eternal: 'guilda.guerraEterna'
};

function formatoDeGuerra(bruto: string): string {
  const chave = FORMATO_GUERRA[bruto];
  return chave === undefined ? bruto : t(chave);
}

interface GuildProps {
  name: string;
  tag: string;
  guildName: string;
  onAccept(): void;
  onRefuse(): void;
}

export function GuildInviteGump({ name, tag, guildName, onAccept, onRefuse }: GuildProps) {
  useFechar(onRefuse, { modal: true });

  return (
    <div className="modal" role="presentation" onClick={onRefuse}>
      <div role="dialog" aria-modal="true" aria-labelledby="guild-invite-title" onClick={e => e.stopPropagation()}>
        <Gump
          title={t('guilda.titulo')}
          action={
            <button type="button" className="btn btn--tiny btn--ghost" onClick={onRefuse} aria-label={t('comum.fechar')}>×</button>
          }
        >
          <div className="stack">
            <p id="guild-invite-title">{t('guilda.convidaVoce', { nome: name, tag, guilda: guildName })}</p>
            <div className="row row--split">
              <button type="button" className="btn btn--ghost" onClick={onRefuse}>{t('comum.recusar')}</button>
              <button type="button" className="btn btn--primary" onClick={onAccept}>{t('comum.aceitar')}</button>
            </div>
          </div>
        </Gump>
      </div>
    </div>
  );
}

interface AllyProps {
  fromTag: string;
  fromName: string;
  onAccept(): void;
  onRefuse(): void;
}

export function AllianceInviteGump({ fromTag, fromName, onAccept, onRefuse }: AllyProps) {
  useFechar(onRefuse, { modal: true });

  return (
    <div className="modal" role="presentation" onClick={onRefuse}>
      <div role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
        <Gump title={t('guilda.alianca')} action={<button type="button" className="btn btn--tiny btn--ghost" onClick={onRefuse}>×</button>}>
          <div className="stack">
            <p>{t('guilda.propoeAlianca', { tag: fromTag, nome: fromName })}</p>
            <div className="row row--split">
              <button type="button" className="btn btn--ghost" onClick={onRefuse}>{t('comum.recusar')}</button>
              <button type="button" className="btn btn--primary" onClick={onAccept}>{t('comum.aceitar')}</button>
            </div>
          </div>
        </Gump>
      </div>
    </div>
  );
}

interface WarProps {
  fromTag: string;
  fromName: string;
  format: string;
  onAccept(): void;
  onRefuse(): void;
}

export function WarInviteGump({ fromTag, fromName, format, onAccept, onRefuse }: WarProps) {
  useFechar(onRefuse, { modal: true });

  return (
    <div className="modal" role="presentation" onClick={onRefuse}>
      <div role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
        <Gump title={t('guilda.guerra')} action={<button type="button" className="btn btn--tiny btn--ghost" onClick={onRefuse}>×</button>}>
          <div className="stack">
            <p>{t('guilda.declaraGuerra', { tag: fromTag, nome: fromName, formato: formatoDeGuerra(format) })}</p>
            <div className="row row--split">
              <button type="button" className="btn btn--ghost" onClick={onRefuse}>{t('comum.recusar')}</button>
              <button type="button" className="btn btn--primary" onClick={onAccept}>{t('comum.aceitar')}</button>
            </div>
          </div>
        </Gump>
      </div>
    </div>
  );
}
